// extracted by mini-css-extract-plugin
export default {"emphasisedText":"ListingTitle_emphasisedText__CBIF0 h3","blackText":"ListingTitle_blackText__mPHkx h3"};